import moment from 'moment';
import { TableColumn } from 'tea-component';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import {
  getFormatNumPlus,
  getFormatPercentPlus,
  toFirstUpperCase,
  isValidNumber,
} from '@gp/utils/common';
import { CONSTANT_KEYS, CONSTANT_TEXTS } from '@gp/constants/const';
import {
  BUDGET,
  ACTUAL_FORECAST,
  ACTUAL,
  FORECAST,
  COMPLETE,
} from '@gp/constants/budgetActualOrForecastCompletionEChart';

import React from 'react';

/* const DATE_FORMAT = 'YYYY-MM-DD';
const generateDates = (startDate?: string, endDate?: string) => {
  const dates: string[] = [];
  let startDateM = moment(startDate);
  let endDateM = moment(endDate);
  let diff = 0;
  if (!endDate || !endDateM.isValid()) return [];
  endDateM = endDateM.startOf('month');
  if (!startDate || !startDateM.isValid()) {
    startDateM = moment(endDateM).startOf('year');
  } else {
    startDateM = startDateM.startOf('month');
  }
  diff = endDateM.diff(startDateM, 'months');

  for (let i = 1; i < diff; i++) {
    const date = moment(startDateM).add(i, 'months');
    dates.push(date.format(DATE_FORMAT));
  }

  if (diff === 0) {
    return [endDateM.format(DATE_FORMAT)];
  }

  return [
    startDateM.format(DATE_FORMAT),
    ...dates,
    endDateM.format(DATE_FORMAT),
  ];
}; */
const generateDates = (year: string): string[] => {
  const dates: string[] = [];
  if (!isValidNumber(year)) return dates;
  for (let i = 1; i < 13; i ++) {
    dates.push(`${year}-${i < 10 ? `0${i}` : i}-01`);
  }

  return dates;
}

const getDateHeader = (date: string): string => {
  if (date?.toLowerCase() === CONSTANT_KEYS.FULL_YEAR) return CONSTANT_TEXTS.FULL_YEAR;
  if (date?.toLowerCase() === CONSTANT_KEYS.YTM) return CONSTANT_TEXTS.YTM;
  const dateM = moment(date);
  return date && dateM.isValid() ? dateM.format('YYYY-MM') : date || '-';
};

const getProjectHeaderStr = (total: number): string => {
  // @ts-ignore
  const totalNum = Number.parseInt(total, 10);
  if (Number.isNaN(totalNum)) return 'Projects';
  return `Projects (${totalNum})`;
};

const renderProject = (
  cvm: IBudgetActualOrForecastCompleteTableData,
): React.ReactElement | string => {
  if (!cvm || !cvm?.name) return '-';
  if (cvm?.name?.toLowerCase() === 'total') return 'Total';
  return (
    <section className="dbg-project-item-info">
      <GeneralImageNew
        className="dbg-project-item-info-img"
        domain="game"
        width={34}
        height={34}
        // style={{ borderRadius: '6px' }}
        src={cvm?.cover}
      />
      <section className="right-info">
        <EllipsisTextBubble
          className="dbg-project-item-info-text"
          text={cvm?.name || '-'}
          // style={{
          //   color: '#000',
          //   fontSize: 14,
          // }}
          bubbleStyle={
            {
              // height: 20,
              // lineHeight: '20px',
            }
          }
        />
      </section>
    </section>
  );
};

const renderDataCell = (
  cvm: IBudgetActualOrForecastCompleteTableData,
  date: string,
): React.ReactElement => {
  const cellData = cvm?.detail?.[date];
  const budget = getFormatNumPlus(cellData?.[BUDGET]);
  // const actualOrForecast = cellData?.actual_or_forecast === 'actual' ? getFormatNumPlus(cellData?.[ACTUAL_FORECAST]) : '-';
  const actual = getFormatNumPlus(cellData?.[ACTUAL]);
  const forecast = getFormatNumPlus(cellData?.[FORECAST]);
  const complete = getFormatPercentPlus(cellData?.[COMPLETE]);
  return (
    <div className="dbg-table-line-box">
      <div className="dbg-table-line-text" title={actual}>
        {actual}
      </div>
      {/* <span className="completion-text gray-text"></span> */}
      <div className="dbg-table-line-text" title={forecast}>
        {forecast}
      </div>
      <div className="dbg-table-line-flex">
        <span title={budget}>{budget}</span>
        <span title={complete} className="completion-text gray-text">
          {complete}
        </span>
      </div>
    </div>
  );
};

const getColumns = (
  module: 'revenue' | 'profit' = 'revenue',
  dates: string[],
  total: number,
): TableColumn<IBudgetActualOrForecastCompleteTableData>[] => {
  const opt: TableColumn<IBudgetActualOrForecastCompleteTableData>[] = [
    {
      key: 'poject',
      header: () => {
        return <>{getProjectHeaderStr(total)}</>;
      },
      width: 224,
      align: 'left',
      fixed: 'left',
      render: (cvm) => {
        return <div className="dbg-table-bold">{renderProject(cvm)}</div>;
      },
    },
    {
      key: 'category',
      header: () => {
        return 'Category';
      },
      width: 180,
      align: 'left',
      fixed: 'left',
      render: (cvm) => {
        return (
          <div className="dbg-table-line-box">
            <div className="dbg-table-line-text">
              Actual {toFirstUpperCase(module) || '-'}($)
            </div>
            <div className="dbg-table-line-text">
              Forecast {toFirstUpperCase(module) || '-'}($)
            </div>
            <div className="dbg-table-line-text">
              <span>Budget {toFirstUpperCase(module) || '-'}($)</span>
              <br />
              <span /* className="gray-text" */>+ Completion%</span>
            </div>
          </div>
        );
      },
    },
  ];
  if (Array.isArray(dates) && dates?.length) {
    // 添加Full Year列、YTM列
    dates.unshift(CONSTANT_KEYS.FULL_YEAR, CONSTANT_KEYS.YTM);
    for (let i = 0; i < dates?.length; i++) {
      const date: string = dates?.[i];
      opt.push({
        key: date,
        header: getDateHeader(date),
        width: 190,
        align: 'right',
        render: (cvm) => renderDataCell(cvm, date),
      });
    }
  }

  return opt;
};

export { getColumns, generateDates };
